export const createProjects = ({ BeURL, projects, showAlert, handleTopClear, setProjects }) => {
    fetch(`${BeURL}/candidate-projects`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ projects }),
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                showAlert(data.message);
                setProjects(data.projects)
                handleTopClear()
                window.location.reload()
            } else {
                showAlert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in create Projects", err);
        });
}
